import React from "react";
import TestimonialSlider from "./TestimonialSlider";
import Testimonial from "./Testimonial";
import Success from "./Success";
import Banner from "../Common/Banner";

export default function TestimonialPage() {
  return (
    <div>
      <Banner title="Testimonials" currentpage="Testimonials" />
      <div className="container my-5">
        <Testimonial show={false} />
      </div>

      <TestimonialSlider />
      <Success />
    </div>
  );
}
